import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconInProgress = /*@__PURE__*/ proxyCustomElement(class CosmosIconInProgress extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'e99566c7e74e5a72817adf4964d0e11ee47b45f4', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8d62765773d3acb619e79fabe82509709f65dfbf', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f865130b892e974a6eeace2167aec48b03be4df3', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.75 2a.75.75 0 0 0-.75.75v16.5c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75V2.75a.75.75 0 0 0-.75-.75z", fill: "currentColor" }), h("path", { key: 'f6ccdfbf542f4359f2c83efd72ed00a91aad2b85', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m8.595 15.098 6.605-3.757a.39.39 0 0 0 .18-.338.39.39 0 0 0-.18-.339L8.596 6.907a.27.27 0 0 0-.315.015.4.4 0 0 0-.143.33v7.515c.002.129.06.247.152.314a.28.28 0 0 0 .306.017", fill: "#fff" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-in-progress", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-in-progress"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-in-progress":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconInProgress);
            }
            break;
    } });
}

export { CosmosIconInProgress as C, defineCustomElement as d };
